import React from 'react';
import _ from 'lodash';
import { TextField, MenuItem, Typography } from '@mui/material';

export const SmallFormTextField = props => {
  const { placeholder, multiline, rows, name, value, id, onChange, error, helperText, select, options, sx, multiple, disabled, whiteSpaceNormal } = props;

  return (
    <TextField
      disabled={disabled || false}
      select={select}
      onChange={onChange}
      error={error}
      helperText={helperText}
      id={id}
      name={name}
      value={value}
      size="small"
      placeholder={placeholder}
      multiline={multiline}
      rows={rows}
      sx={{ width: '60%', ...sx, maxWidth: '1200px' }}
      SelectProps={{
        multiple,
        value,
        MenuProps: {
          style: { zIndex: 35001 }
        }
      }}
    >
      {!_.isNil(options) && options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          <Typography style={ whiteSpaceNormal ? { whiteSpace: 'normal' } : null }>
            {option.label}
          </Typography>
        </MenuItem>
      ))}
    </TextField>
  );
};

